// utils/email-disposable.ts

import DISPOSABLE_DOMAINS from "./disposable-domains-strict";

export function isDisposableEmail(email: string): boolean {
  const at = email.lastIndexOf("@");

  if (at === -1) {
    return false;
  }

  const domain = email.slice(at + 1).toLowerCase();

  return DISPOSABLE_DOMAINS.has(domain);
}
